import { render, staticRenderFns } from "./ActionPanelPao.vue?vue&type=template&id=d0b68858&scoped=true"
import script from "./ActionPanelPao.vue?vue&type=script&lang=js"
export * from "./ActionPanelPao.vue?vue&type=script&lang=js"
import style0 from "./ActionPanelPao.vue?vue&type=style&index=0&id=d0b68858&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b68858",
  null
  
)

export default component.exports